import { ChangeEvent, Dispatch, SetStateAction, useMemo } from "react";
import Input from "../Input/Input";
import _ from "lodash";
import "./QuickSearch.scss";

interface QuickSearchProps {
	setState: Dispatch<SetStateAction<string>>;
	loading: boolean;
	initialValue: string;
}

export default function QuickSearch({ setState, loading, initialValue }: QuickSearchProps) {
	const debounceSearch = useMemo(() => _.debounce(setState, 750), [setState]);

	const onSearchChange = (_event: ChangeEvent<HTMLInputElement>, data: any) => {
		debounceSearch(data.value);
	};

	return (
		<Input
			className={"quick-search"}
			placeholder={"Quick search (UPRN/address)"}
			onChange={onSearchChange}
			loading={loading}
			defaultValue={initialValue}
		/>
	);
}
